import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-work-list-summary-card',
  standalone: false,
  templateUrl: './work-list-summary-card.component.html',
  styleUrl: './work-list-summary-card.component.css',
})
export class WorkListSummaryCardComponent {
  @Input() workItem: any;
  @Input() worktype: string = '';
  @Input() referenceNumber: string = '';
  @Input() status: string = '';
  @Input() createdAt: string | null = '';
}
